import Quill from 'quill'

const Parchment = Quill.import('parchment');

const BlockFontAttributor = new Parchment.Attributor.Style('blockFont', 'font-family', {
    scope: Parchment.Scope.BLOCK
});

export { BlockFontAttributor };
